import { CreatePaymentDto } from '../../pages/users/api/dto/create/CreatePaymentDto'

class CreatePayment {
  constructor(paid: number, description: string | undefined) {
    this.paid = paid
    this.description = description ? description : ''
  }

  private readonly paid: number
  private readonly description: string

  toDto(): CreatePaymentDto {
    return {
      paid: this.paid,
      description: this.description,
    } satisfies CreatePaymentDto
  }
}

export default CreatePayment
